import { getAuthState } from "../../assets/scripts/login-util";
import { axiosPost, axiosGet } from "./axiosFunctions";

const postCaddyMasterUrl                    = '/api/admin/caddy/postCaddyMaster';
const addCaddyDocumentsUrl                  = '/api/admin/caddy/addCaddyDocuments';
const getCaddyMasterUrl                     = '/api/admin/caddy/getCaddyMaster';
const getActiveCaddyMasterAllUrl            = '/api/admin/caddy/getActiveCaddyMasterAll';

const getCaddyReportByCaddyAndDateUrl       = (caddyID, fromDate, toDate) => `/api/admin/caddy/getCaddyReportByCaddyAndDate/${caddyID}/${fromDate}/${toDate}`;
const getCaddyMusterUrl                     = (fromDate, toDate) => `/api/admin/caddy/getCaddyMuster/${fromDate}/${toDate}`;
const getCaddyContactByCaddyIDUrl           = (caddyID) => `/api/admin/caddy/getCaddyContactByCaddyID/${caddyID}`;
const getCaddyDocumentByCaddyIDUrl          = (caddyID) => `/api/admin/caddy/getCaddyDocumentByCaddyID/${caddyID}`;
const updateCaddyAttendanceUrl              = (date, id, isPresent) => `/api/admin/caddy/updateCaddyAttendance/${date}/${id}/${isPresent}`;
const deleteCaddyDocumentUrl                = `/api/admin/caddy/deleteCaddyDocument`;
const getAttendanceSheetUrl                 = '/api/admin/caddy/getAttendanceSheet';  
const getCaddyQueueUrl                      = '/api/admin/caddy/getCaddyQueue';  
const updateCaddyTagUrl                     = '/api/admin/caddy/updateCaddyTag';  
const postCaddyUrl                          = '/api/admin/caddy/postCaddy';  
const addCaddyShuffleUrl                    = '/api/admin/caddy/addCaddyShuffle';  


export const postCaddyMaster = async (caddyMaster, contactList, deletedContactList) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postCaddyMasterUrl, { caddyMaster, contactList, deletedContactList }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getCaddyMasterAll = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet(
        getCaddyMasterUrl,
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getActiveCaddyMasterAll = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet(
        getActiveCaddyMasterAllUrl,
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getCaddyContactByCaddyID = async (caddyID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet(
        getCaddyContactByCaddyIDUrl(caddyID),
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const addCaddyDocuments = async (caddyDocuments) => {
    const token = getAuthState('token');
    if (!token) setTimeout(()=> { return }, 2000);
  
    const response = await axiosPost(
        addCaddyDocumentsUrl,
        { caddyDocuments : caddyDocuments },
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getCaddyDocumentByCaddyID = async (caddyID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet(
        getCaddyDocumentByCaddyIDUrl(caddyID),
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const deleteCaddyDocument = async (deletedDocumentList) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost(
        deleteCaddyDocumentUrl,
        {deletedDocumentList},
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getAttendanceSheet = async(date) => {
    const token = getAuthState('token');
    if(!token) setTimeout(() => { return }, 2000);

    const response = await axiosGet( `${getAttendanceSheetUrl}/${date}`, { headers: { auth_token: `bearer ${token}` } });
    return response;
}

export const updateCaddyAttendance = async(date, id, isPresent) => {
    const token = getAuthState('token');
    if(!token) setTimeout(() => { return }, 2000);

    const response = await axiosGet(updateCaddyAttendanceUrl(date, id, isPresent), { headers: { auth_token: `bearer ${token}` } });
    return response;
}

export const addCaddyShuffle = async(date) => {
    const token = getAuthState('token');
    if(!token) setTimeout(() => { return }, 2000);
    const response = await axiosGet( `${addCaddyShuffleUrl}/${date}`, { headers: { auth_token: `bearer ${token}` } });
    return response;
}

export const getCaddyQueue = async(date) => {
    const token = getAuthState('token');
    if(!token) setTimeout(() => { return }, 2000);
    const response = await axiosGet( `${getCaddyQueueUrl}/${date}`, { headers: { auth_token: `bearer ${token}` } });
    return response;
}

export const updateCaddyTag = async(id, type, tagID, tagName) => {
    const token = getAuthState('token');
    if(!token) setTimeout(() => { return }, 2000);
    const response = await axiosGet( `${updateCaddyTagUrl}/${id}/${type}/${tagID}/${tagName}`, { headers: { auth_token: `bearer ${token}` } });
    return response;
}

export const postCaddy = async(date, caddyID) => {
    const token = getAuthState('token');
    if(!token) setTimeout(() => { return }, 2000);
    const response = await axiosGet( `${postCaddyUrl}/${date}/${caddyID}`, { headers: { auth_token: `bearer ${token}` } });
    return response;
}

export const getCaddyReportByCaddyAndDate = async (caddyID, fromDate, toDate) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    const response = await axiosGet(
        getCaddyReportByCaddyAndDateUrl(caddyID, fromDate, toDate),
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getCaddyMuster = async (fromDate, toDate) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    const response = await axiosGet(
        getCaddyMusterUrl(fromDate, toDate),
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};